import type {
  AddFieldPlacementTarget,
  GeneratedSchemaField,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isPersistedSchemaField } from './is-persisted-schema-field.js'

export function isRequiredPersistedSchemaField(
  loaded: LoadedAuthoredGeneratedSchema,
  field: GeneratedSchemaField,
  target: AddFieldPlacementTarget
): boolean {
  if (loaded.kind === 'form' || target.scope === 'list-item' || !field.required) {
    return false
  }

  return isPersistedSchemaField(field as SchemaField)
}
